function quick(){
    let $menu = $('.quick__item'),
        $btnTop = $('.quick__top'),
        $doc = $('html, body'),
        $contents = $('.p-sec1, .p-sec2, .p-sec3, .p-sec4, .p-sec5, .p-sec6');
    let sclTop = $(window).scrollTop(),
        fixTop = $('.p-header').offset().top + $('.p-header').height();

    if (!(fixTop <= sclTop)) $menu.removeClass('active');
    $menu.on('click', 'a', function(e){
        e.preventDefault();
        let target = $(this).attr("href"),
            offsetTop = $(target).offset().top;
        $doc.stop().animate({ scrollTop :offsetTop }, 800);
    });
    $(window).scroll(function(){
        sclTop = $(window).scrollTop();
        $.each($contents, function(idx, item){
            let $target = $contents.eq(idx),
                i = idx,
                targetTop = $target.offset().top;

            if (targetTop <= sclTop) {
                $menu.removeClass('active');
                $menu.eq(i).addClass('active');
            }
            if (!(fixTop <= sclTop)) $menu.removeClass('active');
        });
        sclTop >= fixTop ? $('.quick').addClass('quick--fix') : $('.quick').removeClass('quick--fix');
    });
    $btnTop.on('click', function(e){
        e.preventDefault();
        $doc.stop().animate({ scrollTop : 0 }, 800);
    });
}

export default quick;


// WEBPACK FOOTER //
// ./src/js/components/quick.js